import { ClienteRouteNames, type ClienteRouteName } from '../../../router/routes'
import welcomeIcon from '../../../assets/Biblioteca/biblioteca_handshake.svg'
import walletIcon from '../../../assets/Biblioteca/biblioteca_wallet.svg'
import shieldIcon from '../../../assets/Biblioteca/biblioteca_shield.svg'
import listIcon from '../../../assets/Biblioteca/biblioteca_list.svg'
import adjuIcon from '../../../assets/Biblioteca/biblioteca_gavel.svg'
import analisisIcon from '../../../assets/Biblioteca/biblioteca_waves.svg'
import escrituIcon from '../../../assets/Biblioteca/biblioteca_paper.svg'
import LiquidaIcon from '../../../assets/Biblioteca/biblioteca_cardHeart.svg'

export interface SupportArticle {
  title: string
  description: string
  routeName?: ClienteRouteName
  hash?: string
  aliases?: string[]
  showInCard?: boolean
}
export interface SupportTopic {
  id: string
  icon: string
  title: string
  description: string
  mobileDescription?: string
  mobileDescriptionBreakpoint?: 'mobile' | 'tablet'
  items: SupportArticle[]
}

export const supportTopics: SupportTopic[] = [
  {
    id: 'bienvenida',
    icon: welcomeIcon,
    title: 'Bienvenida',
    description: 'Todo lo que necesitas para comenzar tu experiencia con HIR Casa.',
    items: [
      {
        title: 'Ayuda y recursos',
        description: 'Canales de atención a clientes.',
        routeName: ClienteRouteNames.materialApoyoContacto,
        showInCard: false
      },
      {
        title: 'Tips para el vendedor de tu inmueble',
        description: 'Información para el vendedor.',
        routeName: ClienteRouteNames.materialApoyoVenta,
        showInCard: false
      },
      {
        title: 'Bienvenida',
        description: 'Conoce cómo empezar tu proceso.',
        routeName: ClienteRouteNames.materialApoyoBienvenida
      },
      {
        title: 'Estrena2',
        description: 'Conoce cómo empezar tu proceso.',
        routeName: ClienteRouteNames.materialApoyoEstrena2
      },
      {
        title: 'Hazte dueña',
        description: 'Conoce cómo empezar tu proceso.',
        routeName: ClienteRouteNames.materialApoyoHazteDuena
      },
      {
        title: 'Tú construye',
        description: 'Conoce cómo empezar tu proceso.',
        routeName: ClienteRouteNames.materialApoyoTuConstruye
      },
      {
        title: 'Preventa',
        description: 'Conoce cómo empezar tu proceso.',
        routeName: ClienteRouteNames.materialApoyoPreventa
      }
    ]
  },
  {
    id: 'pagos',
    icon: walletIcon,
    title: 'Pagos',
    description: 'Consulta opciones de pago, descuentos y servicios relacionados.',
    items: [
      {
        title: 'Factor de actualización',
        description: 'Información sobre el factor de actualización.',
        routeName: ClienteRouteNames.materialApoyoFactorActualizacion,
        showInCard: false
      },
      {
        title: 'Remanentes de monto adjudicado',
        description: 'Consulta tus remanentes.',
        routeName: ClienteRouteNames.materialApoyoRemanentes,
        showInCard: false
      },
      {
        title: 'Pagos y Beneficios',
        aliases: ['Mi financiamiento'],
        description: 'Conoce las formas de realizar tus pagos.',
        routeName: ClienteRouteNames.materialApoyoPagos
      },
      {
        title: 'Descuentos',
        description: 'Consulta los descuentos disponibles.',
        routeName: ClienteRouteNames.materialApoyoDescuentos
      },
      {
        title: 'Domiciliación',
        description: 'Automatiza el pago de tus mensualidades.',
        routeName: ClienteRouteNames.materialApoyoDomiciliacion
      }
    ]
  },
  {
    id: 'seguros',
    icon: shieldIcon,
    title: 'Seguros',
    description: 'Conoce las coberturas, beneficios y protección de tu patrimonio.',

    mobileDescriptionBreakpoint: 'mobile',
    items: [
      {
        title: 'Seguros',
        description: 'Estamos para ayudarte cuando más lo necesitas ',
        routeName: ClienteRouteNames.materialApoyoSeguros
      }
    ]
  },
  {
    id: 'tramites',
    icon: listIcon,
    title: 'Trámites',
    description: 'Encuentra los trámites disponibles y cómo realizarlos.',
    items: [
      {
        title: 'Guía de trámites',
        description: 'Conoce los trámites disponibles y cómo realizarlos.',
        routeName: ClienteRouteNames.materialApoyoGuiaTramites
      },
      {
        title: 'De pagos',
        description: 'Realiza gestiones relacionadas con tus pagos.',
        routeName: ClienteRouteNames.materialApoyoGuiaTramites,
        hash: '#tramites-pagos'
      },
      {
        title: 'De contratos',
        description: 'Consulta y solicita trámites de tu contrato.',
        routeName: ClienteRouteNames.materialApoyoGuiaTramites,
        hash: '#tramites-principales'
      },
      {
        title: 'Aclaraciones',
        description: 'Solicita una revisión o aclaración.',
        routeName: ClienteRouteNames.materialApoyoAclaraciones
      }
    ]
  },
  {
    id: 'adjudicacion',
    icon: adjuIcon,
    title: 'Adjudicación',
    description: 'Descubre el proceso de adjudicación y los pasos a seguir.',
    items: [
      {
        title: 'Guía de adjudicatario',
        aliases: ['guía de adjudicación', 'proceso de adjudicación'],
        description: 'Conoce los pasos para adjudicar tu financiamiento.',
        routeName: ClienteRouteNames.materialApoyoGuiaDeAdjudicacion
      }
    ]
  },
  {
    id: 'analisis-financiero',
    icon: analisisIcon,
    title: 'Análisis financiero',
    description: 'Consulta información sobre tu evaluación y proceso financiero.',
    items: [
      {
        title: 'Entrevista',
        description: 'Material próximamente disponible.'
      }
    ]
  },
  {
    id: 'escrituracion',
    icon: escrituIcon,
    title: 'Escrituración',
    description: 'Prepárate para la firma y escrituración de tu inmueble.',
    items: [
      {
        title: 'Titulación',
        description: 'Información para la titulación de tu inmueble.',
        routeName: ClienteRouteNames.materialApoyoTitulacion,
        showInCard: false
      },
      {
        title: 'Avalúos',
        description: 'Conoce el proceso y requisitos del avalúo.',
        routeName: ClienteRouteNames.materialApoyoAvaluos
      },
      {
        title: 'Firma de escritura',
        description: 'Todo listo para firmar tu escritura.',
        routeName: ClienteRouteNames.materialApoyoFirmaEscrituras
      }
    ]
  },
  {
    id: 'liquidacion',
    icon: LiquidaIcon,
    title: 'Liquidación',
    description: 'Revisa el proceso para liquidar tu financiamiento o cancelar tu hipoteca.',

    mobileDescriptionBreakpoint: 'tablet',
    items: [
      {
        title: 'Liquidación de hipoteca',
        description: 'Es hora de disfrutar de tu nuevo inmueble y celebrar todo lo que has logrado.',
        routeName: ClienteRouteNames.materialApoyoLiquidacionDeHipoteca
      },
      {
        title: 'Liberación y cancelación de hipoteca',
        description: '¡Libérate de la hipoteca y toma las llaves de tu patrimonio!',
        routeName: ClienteRouteNames.materialApoyoLiberacionCancelacion
      }
    ]
  }
]

export interface SupportSearchResult extends SupportArticle {
  category: string
}
const normalize = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()

// Both navigation and search consume this catalogue. No parallel route list.
export function searchSupportArticles(query: string, topics: SupportTopic[] = supportTopics): SupportSearchResult[] {
  const words = normalize(query).split(/\s+/).filter(Boolean)
  if (!words.length) return []
  const phrase = words.join(' ')
  const rank = (item: SupportSearchResult) => {
    const title = normalize(item.title)
    if (title === phrase) return 100
    if (title.startsWith(phrase)) return 90
    if (item.aliases?.some(alias => normalize(alias).includes(phrase))) return 80
    if (words.every(word => title.includes(word))) return 70
    return item.showInCard === false ? 0 : 1
  }
  return topics
    .flatMap(topic =>
      topic.items
        .filter(item => {
          if (!item.routeName) return false
          const text = normalize([topic.title, item.title, item.description, ...(item.aliases ?? [])].join(' '))
          return words.every(word => text.includes(word))
        })
        .map(item => ({ ...item, category: topic.title }))
    )
    .sort((a, b) => rank(b) - rank(a))
    .slice(0, 8)
}
